"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var Link = function Link(props) {
  var value = props.value,
      onClick = props.onClick,
      onRemove = props.onRemove;
  var exists = (value === null || value === void 0 ? void 0 : value.title) && (value === null || value === void 0 ? void 0 : value.url);
  return /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical"
  }, exists && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_antd.Typography, {
    children: value.title
  }), /*#__PURE__*/_react.default.createElement(_antd.Input, {
    size: "small",
    value: value.url,
    disabled: true
  })), /*#__PURE__*/_react.default.createElement(_antd.Space, null, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    children: exists ? 'Edit' : 'Add',
    onClick: onClick,
    size: "small"
  }), exists && /*#__PURE__*/_react.default.createElement(_antd.Button, {
    children: "Remove",
    onClick: onRemove,
    size: "small",
    danger: true
  })));
};

var _default = Link;
exports.default = _default;